import { Component, ViewChild, OnInit } from '@angular/core';
import { Platform, MenuController } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicioService } from './services/servicio.service';
import { CartService } from './services/cart.service';
import { CartComponent } from './shared/cart/cart.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private platform: Platform,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private menu: MenuController,
    private service: ServicioService,
    private cartService: CartService
  ) {
    this.initializeApp();
  }

  // public estilo
  public estilo: string;

  // @ViewChild('headerAPP', { static: true }) valor: CartComponent

  public appPages = [
    {
      title: 'Principal',
      url: '/home',
      icon: 'home'
    }
  ];
  componentReference: any;

  pais;

  url;

  initializeApp() {
    this.platform.ready().then(() => {
    });
  }

  async ngOnInit() {

    // this.actualizarCarro();
    await this.service.publishCartData({
      ev: 'ver'
    });

    await this.service.publishCountryData({
      ev: 'ver'
    });

    // this.service.getObservable().subscribe((data) => {

    //   if (data.ev === 'changePais') {
    this.getPais();
    //   }

    //   // if (data.ev === 'visible') {
    //   //   this.valor.visible = true;
    //   // }

    //   // if (data.ev === 'estilo') {
    //   //   this.estilo = '60px';
    //   // }

    //   this.service.getVariable('pais').then((val) => {
    //     this.pais = val;
    //   });

    // });

    // this.getPais();

    // this.getCart();

    // this.url = window.location.href;
    // if (this.url.includes('/inicio') || this.url.substr(this.url.length - 5) === '8100/' || this.url.substr(this.url.length - 5) === '.com/') {
    //   // this.valor.visible = false;
    //   this.estilo = '60px';
    // } else {
    //   this.estilo = '60px';
    // }
  }

  // async getCart() {
  //   await this.cartService.getCountItems().then(res => {
  //     // this.valor.countCart = res;
  //   });
  // }

  async getPais() {
    await this.service.getVariable('pais').then(res => {
      this.pais = res;
    });
  }

  onActivate(componentRef) {
    this.componentReference = componentRef;
    this.menu.close();
  }

  async goToHome() {
    this.service.getVariable('pais').then(async res => {
      this.pais = res;
      this.service.setVariable('tipoTienda', '360');
      await this.router.navigateByUrl('/select/' + this.pais, { replaceUrl: true });
      this.menu.close();
    });
  }

  async goToNew() {
    await this.router.navigateByUrl('/nuevascolecciones');
    this.menu.close();
  }

  async goToOffer() {
    await this.router.navigateByUrl('/ofertas');
    this.menu.close();
  }

  async irATienda3d() {
    this.service.getVariable('pais').then(async res => {
      this.pais = res;
      this.service.setVariable('tipoTienda', '360');
      // this.router.navigate(['/select/' + this.pais]);
      await this.router.navigateByUrl('/home/' + this.pais);
      // this.router.navigate(['/home/' + this.pais]);
      this.menu.close();
    });

  }

  async irAShowRoom() {
    this.service.getVariable('pais').then(async res => {
      this.pais = res;
      this.service.setVariable('tipoTienda', 'showr');
      await this.router.navigateByUrl('/home/' + this.pais, { replaceUrl: true });

      this.menu.close();
    });
  }

  bolsaCompras() {
    if (this.componentReference.mostrarCarro) {
      this.componentReference.mostrarCarro();
      this.menu.close();
    }
  }

  buscarReferencia() {
    if (this.componentReference.searchBar) {
      this.componentReference.searchBar();
      this.menu.close();
    }
  }

  async solutionGuide() {
    // this.router.navigate(['solutionguide/']);
    await this.router.navigateByUrl('/solutionguide');
    this.menu.close();
  }

  async mostrarTienda(tipo: string) {

    await this.service.setVariable('filtro', [])

    if (this.pais === 'co' || this.pais === undefined) {
      this.pais = 'co';
      this.service.setVariable('pais', this.pais);
      await this.router.navigateByUrl('/home', { replaceUrl: true });
      await this.router.navigateByUrl('/tienda?tipo=' + tipo);
    } else {
      await this.router.navigateByUrl('/tienda/' + this.pais + '?tipo=' + tipo);
    }
    await this.menu.close()
  }

}
